import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import myImg from "../../Assets/afterschool5.jpeg";
import Tilt from "react-parallax-tilt";


import Button from "react-bootstrap/Button";
import { useNavigate } from "react-router-dom";


function Afterschool2() {

  const navigate = useNavigate(); // Initialize navigate

  const handleClick = () => {
    navigate("/registration#afterschool-section"); // This will navigate to the "/another-page" route
  };




    const videoId = "5mPU-mIQgoQ"; 
return (
    <Container fluid className="home-about-section" id="about">
    <Container>
        <Row>
        <Col md={8} className="home-about-description">
            <h1 style={{ fontSize: "2.6em" }}>
            AFTERSCHOOL <span className="purple"> PROGRAMS</span> 
            </h1>
            <p className="home-about-body">
                       At Choicest Fruit, we believe that every young person deserves access to high-quality
                        educational opportunities, no matter their background. Our afterschool programs 
                        combine hands-on tech learning with <span className="purple">homework support</span>, <span className="purple">mentoring</span>, and <span className="purple">real-world
                         problem-solving</span>, designed to inspire curiosity, creativity, and confidence.
                        <br />
                        <br />
                        <h2>Why Afterschool Programs Matter</h2>
                        Afterschool time is a powerful opportunity for youth to learn, explore, and grow in 
                        a safe and supportive environment. Our programs:      
                        <li><span className="purple">Bridge the Opportunity Gap:</span> We serve under-resourced communities where access to 
                          enriching activities may be limited. By bringing programs directly to neighborhoods,
                           we eliminate transportation barriers and ensure all youth can participate.</li>
                        <li><span className="purple">Support Academic Success:</span> Our homework help and tutoring components help students
                           stay on track in school while building critical thinking and problem-solving skills.</li>
                        <li><span className="purple">Inspire Interest in STEM:</span> Through fun, project-based learning, students explore coding,
                           robotics, app development, and maker projects, sparking curiosity and preparing them 
                        for future careers in technology.</li>                        
                        <li><span className="purple">Foster Social-Emotional Learning:</span> Our programs emphasize collaboration, communication,
                           and resilience, helping students build confidence and interpersonal skills.</li>
                         <br />
                         <br />
                        <h2>Our Approach</h2>
                         <br />
                         <li><span className="purple">Neighborhood-Based Programs:</span> We bring learning directly to youth by hosting programs in apartment complexes, local schools, libraries, and community centers. By eliminating transportation barriers, we ensure that every child has the opportunity to participate.</li>
                         <li><span className="purple">Hands-On Tech Learning:</span> Students explore coding, robotics, app development, and maker projects in a fun, project-based environment. We integrate real-world problem solving and entrepreneurship concepts to spark creativity and prepare students for future tech careers.</li>
                         <li><span className="purple">Homework Support & Academic Success:</span> Our programs combine technology learning with guided homework help, ensuring students stay on track academically while building critical thinking and problem-solving skills.</li>
                         <li><span className="purple">Mentorship & Role Models:</span> Youth engage with tech professionals, college students, and community volunteers who provide guidance, encouragement, and inspiration, helping students envision their potential in STEM fields and beyond.</li>
                         <li><span className="purple">Community Collaboration:</span> By partnering with local organizations, schools, libraries, and community centers, we expand program reach, foster sustainability, and create a connected network of support for students and families.</li>
                         
          </p>
          <Button onClick={handleClick}>Register Here</Button>
          </Col>
          <Col md={4} className="myAvtar">
            <Tilt>
              <img src={myImg} className="img-fluid" alt="avatar" />
            </Tilt>
          </Col>
        </Row>
        <Row>
          <Col md={12} className="home-about-social">
            <h1>SUMMER INTERNSHIP PROGRAM</h1>
          <Container>    
        {/* Responsive Video */}
        <div style={{ position: 'relative', paddingBottom: '56.25%', height: 0, overflow: 'hidden', maxWidth: '100%', marginBottom: '20px' }}>
                                <iframe
                                    title="YouTube video"
                                    src={`https://www.youtube.com/embed/${videoId}`}
                                    frameBorder="0"
                                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                                    allowFullScreen
                                    style={{
                                        position: 'absolute',
                                        top: 0,
                                        left: 0,
                                        width: '100%',
                                        height: '100%',
                                    }}
                                />
      </div>
    </Container>
           
          </Col>
            </Row>

            
                <Col md={12} className="home-testimonial">
                <h1>TESTIMONIALS</h1>
                </Col>
          
            


      </Container>
    </Container>
  );
}
export default Afterschool2;
